const isJustEat = process.env.IS_JE === 'true';
const isDev = process.env.NODE_ENV !== 'production';
const BASE_CDN_URL = `https://cdn.${isJustEat ? 'just-eat' : '10bis'}.co.il`;

const config = {
  releaseName: `${isJustEat ? 'je' : '10bis'}-next@${process.env.npm_package_version}`,
  isJustEat,
  environment: process.env.ENVIRONMENT || 'production',
  websiteUrl: isJustEat ? 'https://www.just-eat.co.il/' : 'https://www.10bis.co.il/',
  apiBaseUrl: process.env.API_BASE_URL || (isJustEat ? 'https://www.just-eat.co.il/' : 'https://www.10bis.co.il/'),
  bffApiBaseUrl: process.env.NEW_API_BASE_URL || 'https://tenbis-webapigateway-staging.tenbis.cloud/',
  bffApiSessionTokenTTL: process.env.SESSION_TOKEN_TTL || 20,
  legacySiteUrl: process.env.LEGACY_SITE_URL || 'https://www.10bis.co.il/',
  prerenderHost: process.env.PRE_RENDER_HOST || (isJustEat ? 'www.just-eat.co.il' : 'www.10bis.co.il'),
  prerenderToken: process.env.PRE_RENDER_TOKEN,
  port: process.env.PORT || 3000,
  httpsPort: process.env.HTTPS_PORT || 443,
  isDev,
  isForceProxy: process.env.FORCE_PROXY === 'true' || isDev,
  isProxyBFF: process.env.PROXY_BFF === 'true' || isDev,
  isHTTP: process.env.isHTTP === 'true',
  basedir: process.env.BASEDIR || '/next-dev/',
  googleApisKey: process.env.GOOGLEMAPSKEY || (isJustEat ? 'AIzaSyBvHiuSbdrHi6tAn2Idp9qSLKR3EaIlR8o' : 'AIzaSyDQDF682VfAeWY4dW3EELZwm3xltXlV-a4'),
  facebookAppId: isJustEat ? 61585313152633 : 353526365970,
  recaptchaKey: process.env.RECAPTCHA_KEY || '6LcZiC8sAAAAAPrpsEBFA2jMzC_RicWx0mKKoaLn',
  restaurantsMaxMorningPoolCloseTimeHours: process.env.restaurantsMaxMorningPoolCloseTimeHours || 17,
  restaurantsMaxMorningPoolCloseTimeMinutes: process.env.restaurantsMaxMorningPoolCloseTimeMinutes || 0,
  restaurantsEstimatedPoolDeliveryTimeMarginsEnd: process.env.restaurantsEstimatedPoolDeliveryTimeMarginsEnd || 60,
  restaurantsEstimatedPoolDeliveryTimeMarginsStart: process.env.restaurantsEstimatedPoolDeliveryTimeMarginsStart || 30,
  googlePlayLink: process.env.GOOGLE_PLAY_LINK || (isJustEat ? 'https://play.google.com/store/apps/details?id=com.tenbis.justeat' : 'https://play.google.com/store/apps/details?id=com.tenbis.tbapp'),
  iTunesLink: process.env.ITUNES_LINK || (isJustEat ? 'https://apps.apple.com/us/app/justeat/id6755711320' : 'https://itunes.apple.com/us/app/tn-bys/id434368191'),
  cdnUrl: process.env.CDN_URL,
  shoppingCartGuidExpirationMinutes: process.env.SHOPPING_CART_GUID_EXPIRATION_MINUTES || 720,
  storedAddressExpirationMinutes: process.env.STORED_ADDRESS_EXPIRATION_MINUTES || 120,
  defaultCurrency: 'ILS',
  defaultCountry: 'Israel',
  paypalEnvironment: process.env.PAY_PAL_PRODUCTION === 'true' ? 'production' : 'sandbox',
  intercomAppId: process.env.INTERCOM_APP_ID || 'nzqx6uu6',
  enableMenuFetchFromCdn: process.env.ENABLE_MENU_FETCH_FROM_CDN === 'true',
  sentryDns: isJustEat ? 'https://a830610c37a7324a8201efe0a3b79ddf@o408587.ingest.us.sentry.io/4510554939195392' : 'https://88e180ce469f405fa599dcd4dbfe134f@o408587.ingest.sentry.io/5755643',
  menuFetchFromCdnUrl: process.env.MENU_URL_CDN || `${BASE_CDN_URL}/restaurant-menu/`,
  enableCityDescriptionFetchFromCdn: process.env.ENABLE_CITY_SEO_FETCH_FROM_CDN === 'true',
  seoCityDescriptionFetchFromCdnUrl:
    process.env.CITY_SEO_TEXT_CDN || `${BASE_CDN_URL}/seo-for-cities-and-cuisine-types/`,
  renderRestaurantLogo: process.env.RENDER_RESTAURANT_LOGO === 'true' || false,
  baseCdnUrl: process.env.BASE_CDN_URL || BASE_CDN_URL,
  enableJetFm: true,
  googleLoginClientKey: process.env.GOOGLE_LOGIN_CLIENT_KEY,
  googleTagManagerId: process.env.GOOGLE_TAG_MANAGER_ID || (isJustEat ? 'GTM-TR7JRFXS' : 'GTM-N57PQCNF'),
  brandName: isJustEat ? 'Just Eat' : '10bis',
};

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.info('current config (printed only on dev):', config);
}

module.exports = config;
